import { useQuery } from '@tanstack/react-query'
import { maternityService } from '../services/maternityService'
import { formatDate } from '../utils/locale'
import { calculateGestationalAge } from '../utils/dueDateCalculator'
import './ActivePregnancyPrescribingAlert.css'

interface ActivePregnancyPrescribingAlertProps {
  patientId: string
}

export function ActivePregnancyPrescribingAlert({ patientId }: ActivePregnancyPrescribingAlertProps) {
  const { data: pregnancies } = useQuery({
    queryKey: ['pregnancies', patientId],
    queryFn: () => maternityService.getPregnancies(patientId),
    enabled: !!patientId,
  })

  const activePregnancy = pregnancies?.find((p) => p.status === 'active')
  if (!activePregnancy) return null

  const gestationalAge = calculateGestationalAge(activePregnancy.lastMenstrualPeriod)

  return (
    <div
      className="active-pregnancy-prescribing-alert"
      role="alert"
      aria-live="polite"
    >
      <span className="active-pregnancy-prescribing-alert-icon" aria-hidden="true">
        🤰
      </span>
      <div className="active-pregnancy-prescribing-alert-content">
        <strong>Active pregnancy</strong>
        <span className="active-pregnancy-prescribing-alert-details">
          EDD: {formatDate(activePregnancy.estimatedDueDate)} · Gestation: {gestationalAge.display}
        </span>
        <span className="active-pregnancy-prescribing-alert-message">
          Consider medication safety in pregnancy when prescribing.
        </span>
      </div>
    </div>
  )
}
